module.exports = "/assets/data/2b9795e5657b9fe83c9dc731a563ee20-BN5.data.json";